import { useQuery } from 'react-query';
import { LiveFeedEventTime, Sort } from '../domain';
import { apiHttpService } from './apiHttpService';
import { orderBy } from 'lodash';

interface UseEventTimesParams {
  eventId?: string | null;
  classId?: String | null;
  searchQuery: string;
  sort?: Sort;
}
export function useEventTimes({
  eventId,
  classId,
  searchQuery,
  sort,
}: UseEventTimesParams) {
  return useQuery<LiveFeedEventTime[]>(
    ['eventTimes', eventId, classId],
    async () => {
      const { data } = await apiHttpService.get<{
        times: LiveFeedEventTime[];
      }>(
        `/GetEventTimes?eventId=${eventId}&classId=${classId}`,
      );

      return data.times;
    },
    {
      enabled: !!eventId && !!classId,
      staleTime: Infinity,
      select: (data) => {
        let processedData = searchQuery
          ? data.filter(
              (item) =>
                item.riderFullName
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase()) ||
                item.customHorseName
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase()),
            )
          : data;

        processedData = sort
          ? orderBy(processedData, sort?.field, sort?.order)
          : orderBy(processedData, 'drawnOrder', 'asc');

        return processedData;
      },
    },
  );
}
